// chatHtml.js
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

// Simple, predictable "HTML-ish" detector (keeps behaviour identical across app)
export const looksLikeHtml = (str) => /<\/?[a-z][\s\S]*>/i.test(String(str || ''));

// Centralised config so you can tighten/loosen later in one place
const PURIFY_CONFIG = { USE_PROFILES: { html: true } };

// Sanitize once, parse once — callers shouldn't touch DOMPurify/html-react-parser directly
export const sanitizeHtml = (html) => DOMPurify.sanitize(html ?? '', PURIFY_CONFIG);
export const renderSafeHtml = (html) => parse(sanitizeHtml(html));
